export default __webpack_public_path__ + "assets/images/4709e744e5ae686225e009669ab9acb4.png";